import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Toolbar,
  Editing,
  Item,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import { Button, SelectBox } from "devextreme-react";
import { formatMessage } from "devextreme/localization";

export default function RoleDetailTableList({
  roleDetail,
  isXSmall,
  role,
  middleware,
  dataGrid,
  onValueChanged,
  filterStatus,
}) {
  const changeDisplayedName = () => {
    const language = localStorage.getItem("locale");
    const object = {
      vi: "textVi",
      en: "text",
      ja: "textJa",
    };
    return object[language] ?? "textVi";
  };
  return (
    <DataGrid
      height={document.documentElement.offsetHeight - 189}
      showBorders={true}
      showRowLines={true}
      hoverStateEnabled={true}
      rowAlternationEnabled={true}
      columnResizingMode="widget"
      columnAutoWidth={true}
      allowColumnResizing={true}
      columnHidingEnabled={true}
      alignment="center"
      ref={(el) => (dataGrid = el)}
      dataSource={roleDetail}
    >
      <Editing
        mode="batch"
        useIcons={true}
        allowUpdating={middleware && middleware.WriteState}
        allowAdding={middleware && middleware.CreateState}
        // allowDeleting={true}
      />
      <Selection
        mode="multiple"
        selectAllMode="page"
        showCheckBoxesMode="always"
      />
      <FilterRow visible={true} />
      <Paging defaultPageSize={10} />
      <Pager
        showPageSizeSelector={true}
        allowedPageSizes={[10, 20, 50, 100]}
        showInfo={true}
        visible={true}
      />
      <Column
        caption={formatMessage("NavigationName")}
        dataField={`Navigation.${changeDisplayedName()}`}
        dataType="string"
        allowSearch={true}
      />
      <Column
        caption={formatMessage("Navigate")}
        dataField="NavigateState"
        alignment="center"
      />
      <Column
        caption={formatMessage("Read")}
        dataField="ReadState"
        alignment="center"
      />
      <Column
        caption={formatMessage("Create")}
        dataField="CreateState"
        alignment="center"
      />
      <Column
        caption={formatMessage("Edit")}
        dataField="WriteState"
        alignment="center"
      />
      <Column
        caption={formatMessage("Delete")}
        dataField="DeleteState"
        alignment="center"
      />
      <Column
        caption={formatMessage("Export")}
        dataField="ExportState"
        alignment="center"
      />
      <Column
        caption={formatMessage("Import")}
        dataField="ImportState"
        alignment="center"
      />
      <Column
        caption={formatMessage("Approval")}
        dataField="ApproveState"
        alignment="center"
      />
      <Column
        caption={formatMessage("Remarks")}
        dataField="Remarks"
        alignment="center"
      />

      <Toolbar className="datagrid-toolbar-actions">
        <Item location="before" locateInMenu={isXSmall ? "always" : "auto"}>
          <div className="form_select_box_list">
            {middleware && middleware.ReadState && (
              <>
                <span className="name">{formatMessage("Role")}: </span>
                <SelectBox
                  dataSource={role}
                  placeholder="Select role..."
                  displayExpr="RoleName"
                  valueExpr="RoleName"
                  defaultValue={filterStatus}
                  onValueChanged={(e) => onValueChanged(e)}
                />
              </>
            )}
          </div>
        </Item>
        <Item location="after" locateInMenu={isXSmall ? "always" : "auto"}>
          {middleware && middleware.CreateState && (
            <Button
              icon="save"
              text={formatMessage("Save")}
              onClick={() => {
                dataGrid.instance.saveEditData();
              }}
              type="default"
              width={120}
              className="mr-1"
              stylingMode="outlined"
            />
          )}
          <Button
            onClick={() => dataGrid.instance.refresh()}
            icon="clear"
            text={formatMessage("Cancel")}
          />
        </Item>
      </Toolbar>
    </DataGrid>
  );
}
